import { formatToCamelCase } from '@utils/formatters';

export const resolve = <T = unknown>(data: unknown, delayMs = 0): Promise<T> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(formatToCamelCase(data) as T);
    }, delayMs);
  });
